export function PatriaWordmark({ size = "md", className = "" }) {
  const sizes = {
    sm: "text-lg",
    md: "text-2xl",
    lg: "text-4xl",
    xl: "text-5xl sm:text-6xl",
  };
  return (
    <span
      className={`patria-wordmark ${sizes[size] || sizes.md} ${className}`}
      data-testid="patria-wordmark"
    >
      Patria
    </span>
  );
}
